function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = [
    "item",
    "applyValue",
    "apiRef",
    "focusElementRef",
    "isFilterActive",
    "clearButton",
    "tabIndex",
    "label",
    "variant",
    "InputLabelProps"
];
import * as React from 'react';
import PropTypes from 'prop-types';
import { refType, unstable_useId as useId } from '@mui/utils';
import { styled } from '@mui/material/styles';
import { useGridRootProps } from "../../../hooks/utils/useGridRootProps.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var sanitizeFilterItemValue = function(value) {
    if (String(value).toLowerCase() === 'true') {
        return true;
    }
    if (String(value).toLowerCase() === 'false') {
        return false;
    }
    return undefined;
};
var BooleanOperatorContainer = styled('div')(_define_property({
    display: 'flex',
    alignItems: 'center',
    width: '100%'
}, "& button", {
    margin: 'auto 0px 5px 5px'
}));
function GridFilterInputBoolean(props) {
    var _rootProps_slotProps, _rootProps_slotProps1, _rootProps_slotProps2;
    var item = props.item, applyValue = props.applyValue, apiRef = props.apiRef, focusElementRef = props.focusElementRef, clearButton = props.clearButton, tabIndex = props.tabIndex, labelProp = props.label, _props_variant = props.variant, variant = _props_variant === void 0 ? 'standard' : _props_variant, others = _objectWithoutPropertiesLoose(props, _excluded);
    var _React_useState = _sliced_to_array(React.useState(sanitizeFilterItemValue(item.value)), 2), filterValueState = _React_useState[0], setFilterValueState = _React_useState[1];
    var rootProps = useGridRootProps();
    var labelId = useId();
    var selectId = useId();
    var baseSelectProps = ((_rootProps_slotProps = rootProps.slotProps) === null || _rootProps_slotProps === void 0 ? void 0 : _rootProps_slotProps.baseSelect) || {};
    var _baseSelectProps_native;
    var isSelectNative = (_baseSelectProps_native = baseSelectProps.native) !== null && _baseSelectProps_native !== void 0 ? _baseSelectProps_native : false;
    var baseSelectOptionProps = ((_rootProps_slotProps1 = rootProps.slotProps) === null || _rootProps_slotProps1 === void 0 ? void 0 : _rootProps_slotProps1.baseSelectOption) || {};
    var onFilterChange = React.useCallback(function(event) {
        var value = sanitizeFilterItemValue(event.target.value);
        setFilterValueState(value);
        applyValue(_extends({}, item, {
            value: value
        }));
    }, [
        applyValue,
        item
    ]);
    React.useEffect(function() {
        setFilterValueState(sanitizeFilterItemValue(item.value));
    }, [
        item.value
    ]);
    var label = labelProp !== null && labelProp !== void 0 ? labelProp : apiRef.current.getLocaleText('filterPanelInputLabel');
    return /*#__PURE__*/ _jsxs(BooleanOperatorContainer, {
        children: [
            /*#__PURE__*/ _jsxs(rootProps.slots.baseFormControl, {
                fullWidth: true,
                children: [
                    /*#__PURE__*/ _jsx(rootProps.slots.baseInputLabel, _extends({}, (_rootProps_slotProps2 = rootProps.slotProps) === null || _rootProps_slotProps2 === void 0 ? void 0 : _rootProps_slotProps2.baseInputLabel, {
                        id: labelId,
                        shrink: true,
                        variant: variant,
                        children: label
                    })),
                    /*#__PURE__*/ _jsxs(rootProps.slots.baseSelect, _extends({
                        labelId: labelId,
                        id: selectId,
                        label: label,
                        value: filterValueState === undefined ? '' : String(filterValueState),
                        onChange: onFilterChange,
                        variant: variant,
                        notched: variant === 'outlined' ? true : undefined,
                        native: isSelectNative,
                        displayEmpty: true,
                        inputProps: {
                            ref: focusElementRef,
                            tabIndex: tabIndex
                        }
                    }, others /* FIXME: typing error */ , baseSelectProps, {
                        children: [
                            /*#__PURE__*/ _jsx(rootProps.slots.baseSelectOption, _extends({}, baseSelectOptionProps, {
                                native: isSelectNative,
                                value: "",
                                children: apiRef.current.getLocaleText('filterValueAny')
                            })),
                            /*#__PURE__*/ _jsx(rootProps.slots.baseSelectOption, _extends({}, baseSelectOptionProps, {
                                native: isSelectNative,
                                value: "true",
                                children: apiRef.current.getLocaleText('filterValueTrue')
                            })),
                            /*#__PURE__*/ _jsx(rootProps.slots.baseSelectOption, _extends({}, baseSelectOptionProps, {
                                native: isSelectNative,
                                value: "false",
                                children: apiRef.current.getLocaleText('filterValueFalse')
                            }))
                        ]
                    }))
                ]
            }),
            clearButton
        ]
    });
}
process.env.NODE_ENV !== "production" ? GridFilterInputBoolean.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    apiRef: PropTypes.shape({
        current: PropTypes.object.isRequired
    }).isRequired,
    applyValue: PropTypes.func.isRequired,
    clearButton: PropTypes.node,
    focusElementRef: refType,
    /**
   * It is `true` if the filter either has a value or an operator with no value
   * required is selected (for example `isEmpty`)
   */ isFilterActive: PropTypes.bool,
    item: PropTypes.shape({
        field: PropTypes.string.isRequired,
        id: PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.string
        ]),
        operator: PropTypes.string.isRequired,
        value: PropTypes.any
    }).isRequired
} : void 0;
export { GridFilterInputBoolean };
